import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type ShoppingCartId = Brand<string, 'shoppingCartId'>;

export const SHOPPING_CART_SCHEMA: z.ZodType<IShoppingCart> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as ShoppingCartId)
    .optional(),
  showVat: z.boolean(),
});

export interface IShoppingCart {
  id?: ShoppingCartId;
  showVat: boolean;
}

export const DEFAULT_SHOPPING_CART: IShoppingCart = {
  id: '2ed2a662-f472-459e-bd71-5001ea30600e' as ShoppingCartId,
  showVat: true,
};
